import React from 'react'
import {lifecycle} from 'recompose'
import ContentBox from "../../layout/component/ContentBox";
import Row from "../../bootstrap/component/Row";
import Column from "../../bootstrap/component/Column";
import {formatDateTime} from "../../../util/datetime";
import currentUserHasAccess from "../../../util/widget-helper";
import {WHATSAPP_MESSAGES_WIDGET} from "../../process/ui-definition/process-ui";

const WhatsappMessages = ({whatsappMessageList}) => {
    if (!currentUserHasAccess(WHATSAPP_MESSAGES_WIDGET)) {
        return null
    }

    const templateUrl = "https://docs.google.com/spreadsheets/d/1EjBmFiai9LXxFILgMabRGa44Ht7fbt70kDJJIpi2be0/edit#gid=2128352820";

    return (
        <ContentBox title="WhatsApp Messages">
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                        <tr>
                            <th width="40%">
                                Template name
                            </th>
                            <th width="10%">
                                Sent Date
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            whatsappMessageList.map((whatsappMessage, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{whatsappMessage.templateName}</td>
                                        <td>{formatDateTime(whatsappMessage.sentAt)}</td>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td colSpan={3}>
                                <a target={'_blank'} href={templateUrl}>
                                    Template content
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}


WhatsappMessages.propTypes = {}

export default lifecycle({
    componentDidMount() {
        this.props.initialTableQuery(this.props.processInstanceId)
    }
})(WhatsappMessages)



// WEBPACK FOOTER //
// ./src/modules/whatsapp-messages/component/WhatsappMessages.js